/* ==============================================================================
   Brinde automatico por valor de carrinho (ticket 26e2e201, atualizado em d0fcf705)
   Campanha 13/10/2026: Cueca Boxer Branco Essencia a partir de R$399, ate 23:59:59.

   Arquivo proprio (fora do custom.js) de proposito: custom.js so roda dentro
   de um bloco assincrono que e ignorado em alguns ambientes e depende de jQuery.
   Essa logica mexe com dinheiro no carrinho do cliente, entao carrega direto.

   window.updateCart() (theme.js) e o ponto global que repinta o carrinho.

   Comportamento:
   - A linha do brinde e identificada pela propriedade _brinde_automatico = 'sim'
     (nao pelo produto). Quem compra a mesma cueca por conta propria nao tem a
     dele removida nem descontada do subtotal.
   - Ao carregar a pagina e a cada "cart:refreshed": subtotal sem o brinde >= R$399
     e sem brinde -> adiciona 1 (tamanho M). Caiu abaixo -> remove o brinde.
   - Se o cliente tirar o brinde manualmente acima de R$399, respeita na visita.
   - Depois de END_AT: esconde a regua do brinde, remove qualquer brinde que
     tenha ficado no carrinho e para de agir. Nao depende de data no Liquid
     (licao 2026-10-11: data do Liquid nao vira o dia de forma confiavel aqui).
   ============================================================================= */
(function () {
  var DEFAULT_GIFT_VARIANT_ID = 47675257323776; // Cueca Branco Essencia, tamanho M
  var THRESHOLD_CENTS = 39900; // R$399,00
  var END_AT = Date.parse('2026-10-13T23:59:59-03:00');
  var ADDED_KEY = 'origgoGiftAdded-1310';
  var DISMISS_KEY = 'origgoGiftDismissed-1310';
  var handling = false;

  function isOver() {
    return isNaN(END_AT) || Date.now() >= END_AT;
  }

  function hideRuler() {
    if (document.getElementById('origgo-brinde-off')) return;
    var st = document.createElement('style');
    st.id = 'origgo-brinde-off';
    st.textContent = '.previewCartMessage--brinde,.cart-progress--brinde,.cart-progressbar-wrapper--brinde{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties._brinde_automatico === 'sim');
  }

  function eligibleSubtotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isGiftLine(item)) total += item.original_line_price;
    });
    return total;
  }

  function hasGift(cart) {
    return (cart.items || []).some(isGiftLine);
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: DEFAULT_GIFT_VARIANT_ID,
          quantity: 1,
          properties: { _brinde_automatico: 'sim' }
        }]
      })
    });
  }

  function removeGift(cart) {
    var updates = {};
    cart.items.forEach(function (item) {
      if (isGiftLine(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function repaint() {
    if (typeof window.updateCart === 'function') {
      window.updateCart();
      return;
    }
    fetchCart().then(function (freshCart) {
      document.dispatchEvent(new CustomEvent('cart:refreshed', { detail: { cart: freshCart } }));
    });
  }

  function dropGift(cart) {
    handling = true;
    removeGift(cart).then(function () {
      repaint();
      handling = false;
    }).catch(function () { handling = false; });
  }

  function evaluate(cart) {
    if (handling || !cart || !Array.isArray(cart.items)) return;

    var giftPresent = hasGift(cart);

    if (isOver()) {
      hideRuler();
      if (giftPresent) dropGift(cart);
      return;
    }

    var subtotal = eligibleSubtotal(cart);

    if (subtotal < THRESHOLD_CENTS) {
      try {
        sessionStorage.removeItem(DISMISS_KEY);
        sessionStorage.removeItem(ADDED_KEY);
      } catch (e) {}
      if (giftPresent) dropGift(cart);
      return;
    }

    if (giftPresent) {
      try { sessionStorage.setItem(ADDED_KEY, '1'); } catch (e) {}
      return;
    }

    var wasAdded, dismissed;
    try {
      wasAdded = sessionStorage.getItem(ADDED_KEY) === '1';
      dismissed = sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (e) {
      wasAdded = false;
      dismissed = false;
    }

    if (wasAdded) {
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
      return;
    }

    if (dismissed) return;

    handling = true;
    addGift().then(function (r) {
      if (!r.ok) throw new Error('add gift failed: ' + r.status);
      repaint();
      try { sessionStorage.setItem(ADDED_KEY, '1'); } catch (e) {}
      handling = false;
    }).catch(function () { handling = false; });
  }

  function onCartRefreshed(evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart) {
      evaluate(cart);
    } else {
      fetchCart().then(evaluate).catch(function () {});
    }
  }

  if (isOver()) hideRuler();

  // Vira o dia com a pagina aberta: esconde a regua e limpa o brinde na hora.
  if (!isOver()) {
    var msLeft = END_AT - Date.now();
    if (msLeft < 2147483647) {
      setTimeout(function () {
        hideRuler();
        fetchCart().then(evaluate).catch(function () {});
      }, msLeft + 1000);
    }
  }

  document.addEventListener('cart:refreshed', onCartRefreshed);

  function init() {
    fetchCart().then(evaluate).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
